import React, { useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
 
import { useFormik } from 'formik';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';
import '../layout/sass/_form.scss';
import api from '../api/api';
import { TabelaVaf } from './TabelaVaf';

export const FormVaf = ({ isEditing, isLoading }) => {

    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [intervaloDatas, setIntervaloDatas] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setIntervaloDatas((values) => {
            return {
                ...values,
                [name]: value,
            }
        })
    }

    const formik = useFormik({
        initialValues: {
            "id": 0,
            "nome": "",
            "unPadrao": "",
            "valorUn": 0.0,
            "municipio": "",
            "qtde": 0.0
        },

        enableReinitialize: true,

        onSubmit: async () => {
            setIsSubmiting(true)

            const response = await api.post("/precos/vaf", intervaloDatas)     
            try {
                if (!isEditing) {
                    //formik.resetForm()
                    formik.setValues(response.data)                    

                    response.data === '' ?
                        toast.current.show({ life: 2000, severity: 'error', summary: 'Nenhum movimento encontrado' })
                        :
                        toast.current.show({ life: 2000, severity: 'success', summary: 'Pesquisa concluída!' });

                    setTimeout(() => {
                        history.push('/vaf')
                    }, 2000)

                }
            }
            catch (error) {
                if (!isEditing)

                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao pesquisar!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    function formatDatex(date) {
        var month = date.split("/")[1],
            day = date.split("/")[0],
            year = date.split("/")[2];
        if (month < 10)
            month = '0' + month;
        if (day < 10)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    const filterDateInicio = (value, filter) => {

        if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
            return true;
        }

        if (value === undefined || value === null) {
            return false;
        }

        return new Date(formatDatex(value)) >= new Date(formatDatex(formatDate(filter)));
    }

    const filterDateFim = (value, filter) => {

        if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
            return true;
        }

        if (value === undefined || value === null) {
            return false;
        }

        return new Date(formatDatex(value)) <= new Date(formatDatex(formatDate(filter)));
    }

    const formatDate = (date) => {
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (month < 10) {
            month = '0' + month;
        }

        if (day < 10) {
            day = '0' + day;
        }

        return day + '/' + month + '/' + date.getFullYear()
    }

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Apurador VAF</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">

                        <div className="p-field p-col-12 p-sm-3 p-md-3">
                            <label
                                htmlFor="dataInicial"
                                className={classNames({ 'p-error': isFormFieldValid('dataInicial') })}
                            >
                                Data Inicial
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="dataInicial"
                                        name="dataInicial"
                                        disabledDays={[]}  
                                        value={intervaloDatas.dataInicial}
                                        onChange={handleChange}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('dataInicial') })}
                                        yearRange={`2000:${new Date().getFullYear()}`}
                                        filter
                                        filterMatchMode="custom"
                                        filterFunction={filterDateInicio}

                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.dataInicial && formik.touched.dataInicial &&
                                <ErrorValidationMessage message={formik.errors.dataInicial} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-3 p-md-3">
                            <label
                                htmlFor="dataFinal"
                                className={classNames({ 'p-error': isFormFieldValid('dataFinal') })}
                            >
                                Data final
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="dataFinal"
                                        name="dataFinal"
                                        disabledDays={[]}  
                                        value={intervaloDatas.dataFinal}
                                        onChange={handleChange}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('dataFinal') })}
                                        yearRange={`2000:${new Date().getFullYear()}`}
                                        readOnlyInput={true}
                                        filter
                                        filterMatchMode="custom"
                                        filterFunction={filterDateFim}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.dataFinal && formik.touched.dataFinal &&
                                <ErrorValidationMessage message={formik.errors.dataFinal} />
                            }
                        </div>
                    </div>

                    <div className="p-field p-col-12 p-sm-3 p-md-3">
                        {
                            !isLoading ?
                                <Button
                                    label={'Pesquisar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                    onClick={() => history.push('/vaf')}
                                    disabled={!intervaloDatas.dataInicial || !intervaloDatas.dataFinal}
                                />
                                :
                                <Skeleton width="82.16px" height="35px" />

                        }
                    </div>
                </form>
            </div>
            <TabelaVaf data={formik.values} intervaloDatas={intervaloDatas} />
        </div>

    );
}
